/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  error: '',
  status: 'inactive',
  expires: null,
  indicationAt: null,
  durationInHours: null,
  timeRemainingInSeconds: null
});

export default function securityActivationReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case 'SECURITY_ACTIVATION_POLL_DONE': {
      return state
        .set('error', '')
        .set('status', action.payload.status)
        .set('expires', action.payload.securityActivationEndAt || null)
        .set('indicationAt', action.payload.securityActivationIndicationAt || null)
        .set('durationInHours', action.payload.securityActivationDurationInHours || null)
        .set('timeRemainingInSeconds', action.payload.timeRemainingInSeconds || null);
    }
    case 'SECURITY_ACTIVATION_POLL_FAILED': {
      return INITIAL_STATE.set('error', action.payload);
    }
    case 'SECURITY_ACTIVATION_TIME_OUT': {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
}
